import classnames from 'classnames';
import { forwardRef, HTMLAttributes } from 'react';

import styles from './TableBody.module.scss';

export const TableBody = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={classnames(styles.tableBody, className)}
      data-role="tbody"
      {...props}
    />
  )
);
